import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import classNames from "classnames";
import { startPrint } from "@utils/my-bets/helpers";
import BetItemPayment from "./BetItemPayment";
import BetItemHeaderTableType from "./BetItemHeaderTableType";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetItemHeaderTable(props: {
	toggleDetails: () => void;
	isDetailsDisplayed?: boolean;
	isPrinting?: boolean;
	setIsPrinting: (value: boolean) => void;
}) {
	const { t } = useTranslation("mybets");

	const bet = useContext(MyBetsBetContext);

	useEffect(() => {
		if (props.isPrinting) {
			startPrint(bet.id);
			props.setIsPrinting(false);
		}
	}, [props.isPrinting]);

	const [isHover, setIsHover] = useState(false);

	return (
		<table className="table--bets--reset" cellSpacing={0} cellPadding={0}>
			<tbody>
				<tr>
					<th className="table--bets__th table--bets__th--type">
						<span>{t("ITEM.INFO_DATE")}</span>

						<span>
							{DateTime.fromISO(bet.dateCreated).toLocaleString(
								DateTime.DATETIME_SHORT
							)}
						</span>
					</th>

					<th className="table--bets__th table--bets__th--type">
						<span>{t("ITEM.PICK")}</span>

						<span>
							{bet.betStatus ? <BetItemHeaderTableType /> : null}
						</span>
					</th>

					<th className="table--bets__th table--bets__th--price">
						{bet.betStatus ? (
							<>
								<span>{t<string>("ITEM.INFO_PAYMENT")}:</span>{" "}
								<span className="u-type--wgt--bold">
									{bet.displayPayment}
								</span>
							</>
						) : null}
					</th>

					{bet.betStatus ? <BetItemPayment /> : null}

					<th className="table--bets__th table--bets__th--print">
						{bet.betStatus ? (
							<button
								className="btn btn--square--reset btn--ghost no-print"
								type="button"
								onClick={() => props.setIsPrinting(true)}
								onMouseEnter={() => setIsHover(true)}
								onMouseLeave={() => setIsHover(false)}
							>
								<i
									className={classNames(
										"u-icon u-icon--big u-icon--print",
										{
											"u-color--brand--primary": isHover,
										}
									)}
								/>
							</button>
						) : null}
					</th>
				</tr>
			</tbody>
		</table>
	);
});
